import React, { useState, useEffect } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';
import axios from 'axios';
import moment from 'moment';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../../src/config/firebase';
import IconButton from 'components/common/IconButton';
import PageHeader from 'components/common/PageHeader';
import FileUpload from 'components/doc-components/FileUpload';
import FalconComponentCard from 'components/common/FalconComponentCard';

const CreateTender = () => {
  const navigate = useNavigate();
  const [fileUrl, setFileUrl] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    closingDate: '',
    reference: '',
    contact: '',
    tel: '',
    email: '',
    description: '',
    closingDateDD: '',
    closingDateMM: '',
    closingDateYYYY: '',
    closingTimeHH: '',
    closingTimeMM: ''
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid;
        setFormData({
          ...formData,
          user_id: uid,
        });
      } else {
        navigate('/login');
      }
    });

    return () => unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const date = `${formData.closingDateDD}/${formData.closingDateMM}/${formData.closingDateYYYY}`;

    const { closingDateDD, closingDateMM, closingDateYYYY } = formData;
    const inputDate = new Date(closingDateYYYY, closingDateMM - 1, closingDateDD);
    const today = new Date();
    today.setHours(0, 0, 0, 0);  // set time to 00:00:00.000

    try {
      if (inputDate < today || closingDateYYYY < today.getFullYear() || closingDateMM > 12 || closingDateDD > 31) {
        toast.error('Closing date is invalid.');
        return;
      }
    } catch (error) {
      toast.error('Closing date is invalid.');
      return;
    }

    const { closingTimeHH, closingTimeMM } = formData;
    const closingTime = `${closingTimeHH}:${closingTimeMM}`;
    
    try {
      const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/;
      if (!timePattern.test(closingTime)) {
        toast.error('Closing time is invalid.');
        return;
      }
    } catch (error) {
      toast.error('Closing time is invalid.');
      return;
    }    

    try {
      let formData2 = new FormData();
      formData2.append('name', formData.name);
      formData2.append('date_added', moment.utc().format('YYYY-MM-DD HH:mm'));
      formData2.append('fileUrl', fileUrl);
      formData2.append('closing_date', date);
      formData2.append('closing_time', closingTime);
      formData2.append('reference', formData.reference);
      formData2.append('contact', formData.contact);
      formData2.append('tel', formData.tel);
      formData2.append('email', formData.email);
      formData2.append('description', formData.description);
      formData2.append('attachment', fileUrl);
      formData2.append('attachment_awarded', fileUrl);
      formData2.append('hits', 0);
      formData2.append('fee', 'None');
      formData2.append('status', 'NEW');

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/tenders/create`,
        formData2
      );

      if (response) {
        toast.success('Tender created successfully', {
          theme: 'colored',
        });

        setFormData({
          ...formData,
          name: '',
          closingDate: '',
          reference: '',
          contact: '',
          tel: '',
          email: '',
          description: '',
          closingDateDD: '',
          closingDateMM: '',
          closingDateYYYY: '',
          closingTimeHH: '',
          closingTimeMM: ''
        });
        setFileUrl(null);

        navigate('/tenders/list');
      }
    } catch (err) {
      console.log('Error', err.message);
    }
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    if (name === 'name') {
      setFormData({
        ...formData,
        [name]: value,
        downloadTitle: value.replace(/ /g, '_'),
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  return (
    <>
      <PageHeader
        title='Create a Tender'
        description='Load a new job to appear on the Tenders page'
        className='mb-3'
      ></PageHeader>

      <FalconComponentCard>
        <FalconComponentCard.Header
          title='Details'
          light={false}
          noPreview={true}
        ></FalconComponentCard.Header>
        <Form onSubmit={handleSubmit}>
          <FalconComponentCard.Body>
            <Row>
              <Col lg='12'>
                <Form.Group>
                  <Form.Label>Name <span className="required-asterisk">*</span>
                  </Form.Label>
                  <Form.Control
                    size='lg'
                    type='text'
                    placeholder=''
                    name='name'
                    onChange={handleFieldChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg='12'>
                <Form.Group>
                  <Form.Label>Description   <span className="required-asterisk">*</span>
                  </Form.Label>
                  <Form.Control
                    as='textarea'
                    rows={4}
                    size='lg'
                    type='text'
                    placeholder=''
                    name='description'
                    onChange={handleFieldChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg='6'>
                <Form.Group>
                  <Form.Label>Closing Date  <span className="required-asterisk">*</span>
                  </Form.Label>
                  <Row>
                    <Col>
                      <Form.Control
                        maxLength='2'
                        size='lg'
                        type='text'
                        placeholder='DD'
                        name='closingDateDD'
                        onChange={handleFieldChange}
                        required
                      />
                    </Col>
                    <Col>
                      <Form.Control
                        maxLength='2'
                        size='lg'
                        type='text'
                        placeholder='MM'
                        name='closingDateMM'
                        onChange={handleFieldChange}
                        required
                      />
                    </Col>
                    <Col>
                      <Form.Control
                        maxLength='4'
                        size='lg'
                        type='text'
                        placeholder='YYYY'
                        name='closingDateYYYY'
                        onChange={handleFieldChange}
                        required
                      />
                    </Col>
                  </Row>
                </Form.Group>
              </Col>
              <Col lg='6'>
                <Form.Group>
                  <Form.Label>Closing time  <span className="required-asterisk">*</span>
                  </Form.Label>
                  <Row>
                    <Col>
                      <Form.Control
                        maxLength='2'
                        size='lg'
                        type='text'
                        placeholder='HH'
                        name='closingTimeHH'
                        onChange={handleFieldChange}
                        required
                      />
                    </Col>
                    <Col>
                      <Form.Control
                        maxLength='2'
                        size='lg'
                        type='text'
                        placeholder='MM'
                        name='closingTimeMM'
                        onChange={handleFieldChange}
                        required
                      />
                    </Col>
                  </Row>
                </Form.Group>
              </Col>
              </Row>
              <Row>
              <Col lg='6'>
                <Form.Group>
                  <Form.Label>Reference  <span className="required-asterisk">*</span>
                  </Form.Label>
                  <Form.Control
                    size='lg'
                    type='text'
                    placeholder=''
                    name='reference'
                    onChange={handleFieldChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg='6'>
                <Form.Group>
                  <Form.Label>Contact Person  <span className="required-asterisk">*</span>
                  </Form.Label>
                  <Form.Control
                    size='lg'
                    type='text'
                    placeholder=''
                    name='contact'
                    onChange={handleFieldChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col lg='6'>
                <Form.Group>
                  <Form.Label>Telephone  <span className="required-asterisk">*</span>
                  </Form.Label>
                  <Form.Control
                    size='lg'
                    type='text'
                    placeholder=''
                    name='tel'
                    onChange={handleFieldChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg='6'>
                <Form.Group>
                  <Form.Label>Email  <span className="required-asterisk">*</span>
                  </Form.Label>
                  <Form.Control
                    size='lg'
                    type='email'
                    placeholder=''
                    name='email'
                    onChange={handleFieldChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <FileUpload category={'tenders'} setFileUrl={setFileUrl} />

            <Row>
              <Col lg='6' className='mt-4 mb-3 ml-3'>
                <Form.Group>
                  <IconButton
                    className='mb-1'
                    variant='falcon-default'
                    size='lg'
                    icon='plus'
                    transform='shrink-3'
                    type='submit'
                    disabled={!fileUrl}
                  >
                    Submit
                  </IconButton>
                </Form.Group>
              </Col>
            </Row>
          </FalconComponentCard.Body>
        </Form>
      </FalconComponentCard>
    </>
  );
};

export default CreateTender;